import { getUrlFromMedia } from '@/utils/utils';
import Image from 'next/image';
import Link from 'next/link';

interface SearchItemProps {
    title: string;
    field_image?: {
        field_media_image: {
            uri: {
                url: string;
            }
        }
    };
    image?: {
        uri: {
            url: string;
        };
    };
    path: {
        alias: string;
    };
}

interface SearchItemsProps {
    items: SearchItemProps[];
}

export const SearchItems = ({ items }: SearchItemsProps) => (
    <div className="flex flex-col gap-4 pt-4">
        {(!items || items.length === 0) && (
            <p>No hay resultados disponibles.</p>
        )}

        {items?.map((item, index) => (
            <Link
                key={`search-item-${index}`}
                href={item.path?.alias || "/"}
                className="flex items-center gap-4 group"
            >
                <div className="bg-primary-50 overflow-hidden relative h-20 w-20 shrink-0">
                    <Image
                        src={
                            item.field_image
                                ? getUrlFromMedia(item.field_image)
                                : item.image.uri.url
                        }
                        alt={item.title}
                        width={240}
                        height={240}
                        className="group-hover:scale-110 object-cover absolute w-full h-full"
                    />
                </div>
                <p className='group-hover:underline'>{item.title}</p>
            </Link>
        ))}
    </div>
);
